// API client for admin dashboard overview (ADM-011)
import { apiClient } from './client'

export interface AuditEntry {
  id: number
  action: string
  entity_type: string
  entity_id: string | null
  created_at: string | null
  user_name: string | null
  user_email: string | null
}

export interface AdminOverviewResponse {
  users_active: number
  users_inactive: number
  orgs_count: number
  groups_count: number
  recent_audit: AuditEntry[]
}

export const fetchAdminOverview = async (): Promise<AdminOverviewResponse> => {
  const response = await apiClient.get<AdminOverviewResponse>('/statistics/admin-overview')
  return response.data
}
